import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowsLeftRight, Lock, Envelope } from "@phosphor-icons/react";

export default function AuthPage() {
  const navigate = useNavigate();
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/analisis");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0A0A0A] text-white">
      <div
        className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden border-r border-white/10"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(10,10,10,0.85), rgba(10,10,10,0.92)), url('https://images.unsplash.com/photo-1774646598677-cc38cb3cac00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbWFwJTIwdG9wb2dyYXBoeXxlbnwwfHx8fDE3Nzg0OTM0MzF8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        data-testid="auth-hero"
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 border border-[#FF9800] flex items-center justify-center">
            <ArrowsLeftRight size={20} weight="bold" className="text-[#FF9800]" />
          </div>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/80">
            MATRIZ · O / D
          </span>
        </div>

        <div>
          <p className="label-micro mb-4 text-[#FF9800]">PLATAFORMA · v1.0</p>
          <h1 className="text-5xl lg:text-6xl font-bold tracking-tight leading-[0.95]">
            Matrices Origen / Destino
            <span className="block text-[#00E5FF] mt-2">de la movilidad española.</span>
          </h1>
          <p className="text-white/70 mt-6 max-w-md text-base">
            Explora, filtra y descarga matrices O/D a partir de los datos
            abiertos del MITMA. Distritos, municipios, GAUs y provincias.
          </p>
        </div>

        <div className="flex gap-8 text-xs font-mono uppercase tracking-[0.2em] text-white/50">
          <span>· Distritos</span>
          <span>· Municipios</span>
          <span>· GAU</span>
          <span>· Provincias</span>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/login" className="lg:hidden flex items-center gap-2 mb-8">
            <ArrowsLeftRight className="text-[#FF9800]" size={22} weight="bold" />
            <span className="font-mono text-xs uppercase tracking-[0.25em]">MATRIZ O/D</span>
          </Link>

          <p className="label-micro mb-2">Acceso</p>
          <h2 className="text-3xl font-bold tracking-tight mb-1" data-testid="auth-title">
            Inicia sesión
          </h2>
          <p className="text-white/50 text-sm mb-8">
            Plataforma privada. Solicita acceso a tu administrador si aún no tienes cuenta.
          </p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="label-micro mb-2 inline-block">Email</Label>
              <div className="relative">
                <Envelope className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={16} />
                <Input
                  id="email"
                  data-testid="auth-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@correo.es"
                  className="pl-9 bg-[#121212] border-white/10 rounded-none h-11 focus-visible:ring-[#FF9800]"
                  required
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="label-micro mb-2 inline-block">Contraseña</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={16} />
                <Input
                  id="password"
                  data-testid="auth-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="pl-9 bg-[#121212] border-white/10 rounded-none h-11 focus-visible:ring-[#FF9800]"
                  required
                  minLength={6}
                />
              </div>
            </div>

            {error && (
              <p data-testid="auth-error" className="text-sm text-[#F44336] border border-[#F44336]/30 bg-[#F44336]/10 px-3 py-2 font-mono">
                {error}
              </p>
            )}

            <Button
              type="submit"
              data-testid="auth-submit-btn"
              disabled={loading}
              className="w-full h-11 rounded-none bg-[#FF9800] hover:bg-[#FFA726] text-black font-semibold btn-press tracking-wide"
            >
              {loading ? "Procesando…" : "Entrar"}
            </Button>
          </form>

          <p className="mt-8 label-micro text-white/30">
            ACCESO RESTRINGIDO · LA GESTIÓN DE USUARIOS ES MANUAL
          </p>
        </div>
      </div>
    </div>
  );
}
